<template>
  <div class="all_project">
    <div class="pjt_type">
      <span v-for="types in types" :key="types.id" v-on:click="selected(types)" :class='{selected:typeSelect==types.name}' >{{types.name}}</span>
    </div>
    <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">  
      <ul class="pjt_list">
        <li v-for="(pjtList,index) in pjtList" :key="index">
         <div @click="judgejump(pjtList.id)">
          <div class="bgimg" :class="{'zhaomu':pjtList.status==4,'close':pjtList.status==5,'jinxing':pjtList.status==7,'over':pjtList.status==8,'hezuo':pjtList.status==6,'pingjia':pjtList.status==9}"></div>
          <span class="project_type">{{pjtList.projectType}}</span>
          <h4>{{pjtList.title}}</h4>
          <div class="money">{{pjtList.prePrice}}</div>
          <div class="pjt_skills">
            <span v-for='(pjtList,index) in pjtList.skillsList' :key="index">{{pjtList}}</span>
          </div>
          <div class="position">
            <span><icon name="map-marker"></icon>{{pjtList.city}}</span><span><icon name="clock-o"></icon>{{pjtList.time}}</span>
          </div>
          <div class="people">
            <span>已推荐<span>{{pjtList.countRecommender}}</span>人</span><span>已申请<span>{{pjtList.countOffer}}</span>人</span><span>已浏览<span>{{pjtList.countVisit}}</span>人</span>
          </div>
         </div>
        </li>
      </ul>
    </van-list>
    </mt-loadmore>
    
  </div>
</template>
<script>
import { Indicator, Toast } from 'mint-ui'
import bus from '../utiles/bus'
import Vue from 'vue' 
import {formatDate} from '../assets/js/date.js'
export default {
  name: 'all_project',
  data () {
    return {
      types: [{name: '全部', id: 'all'}],
      pjtList: '',
      typeSelect: '全部',
      searchCondition: {
        pageNo: 0,
        pageSize: '10'
      },
      allLoaded: false,
      scrollMode: 'auto',
      pjtType: 'all',
      skillList: '',
      project: '',
      projectType: false,
      Date: new Date(),
      startTime: '',
      geshu: '',
      newDataNumber: '',
      loading: false,
      finished: false,
      pjttime:''
    }
  },
  created(){
    
  },
  mounted () {
    this.STATE.state.bottomindex='btnTwo'
    this.loadPageList()
    // this.$refs.loadmore.topPullText = '显示最新项目'
    // this.$refs.loadmore.topDropText = '显示最新项目'
    // this.$refs.loadmore.bottomPullText = '显示更多项目'
    // this.$refs.loadmore.bottomDropText = '显示更多项目'
    this.getType()
    var date = new Date();
    console.log(date,"123")
    var month = date.getMonth() + 1;				//月
    var dateDate = date.getDate();					//日
    var dateHours = date.getHours();               //时
    var dateMinutes = date.getMinutes();           //分
    var dateSeconds = date.getSeconds();           //秒
    if (month >= 1 && month <= 9){
      month = "0" + month;
    }
    if (dateDate >= 0 && dateDate <= 9){
      dateDate = "0" + dateDate;
    }
    if(dateHours >= 0 && dateHours <= 9) dateHours="0" + dateHours;
    if(dateMinutes >= 0 && dateMinutes <= 9) dateMinutes="0" + dateMinutes;
    if(dateSeconds >= 0 && dateSeconds <= 9) dateSeconds="0" + dateSeconds;
    // var month = this.Date.getMonth() + 1
    // if(month>1&&month<9){
    //   month = '0'+month
    // }
    // var strDate = this.Date.getDate()
    var seperator1 = '-'
    var seperator2 = ':'
    this.startTime = this.Date.getFullYear() + seperator1 + month + seperator1 + dateDate + ' ' + dateHours + seperator2 + dateMinutes + seperator2 + dateSeconds
  },
  methods: {
    selected: function (types) {
      this.searchCondition.pageNo = 1
      this.typeSelect = types.name
      this.pjtType = types.id
      this.loadPageList()
    },
    onLoad: function () {
      let _this = this
      this.searchCondition.pageNo = this.searchCondition.pageNo + 1
      setTimeout(() => {
        this.axios.get('url/work/project/queryweixinprojectlists?type=' + this.pjtType + '&rows=20&page=' + this.searchCondition.pageNo)
        .then(function (res) {
          if(res){
            // 加载状态结束
            _this.loading = false;
            if(_this.searchCondition.pageNo==1){
              _this.pjtList = res.data
            }else{
              _this.pjtList = _this.pjtList.concat(res.data)
            }
            if (res.data.length <20) {
                _this.finished = true;
            }
          }
        }).catch(function (response) {
        })
      }, 500)
    },
    loadTop: function () {
      this.loadPageList()
      Indicator.close()
      this.tishi()
      this.$refs.loadmore.onTopLoaded()
    },
    loadBottom: function () {
      this.more()
      let _this = this
      if (_this.pjtList.length === 0) {
        Toast({
          message: '没有更多项目了',
          position: 'middle',
          duration: 1000
        })
      } else {
        Toast({
          message: '又加载了' + _this.geshu + '个项目',
          position: 'middle',
          duration: 1000
        })
      }
      this.$refs.loadmore.onBottomLoaded()
    },
    loadPageList: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.axios.get('url/work/project/queryweixinprojectlists?type=' + this.pjtType + '&rows=20&page=1')
      .then(function (res) {
        Indicator.close()
        _this.pjtList = res.data
        // _this.pjttime = res.data[0].createTime
        _this.pjttime=formatDate(new Date(res.data[0].createTime), 'yyyy-MM-dd hh:mm:ss');
        if (res.data.length < 20) {
          _this.finished = true
        }else{
          _this.finished = false
        }
        _this.geshu = res.data.length
      }).catch(function (response) {
        Indicator.close()
      })
    },
    tishi () {
      let _this = this
      console.log(_this.pjttime)
      this.axios.get('url/work/project/queryNewProjectNumber?createTime=' + this.pjttime + '')
      .then(function (res) {
        _this.newDataNumber = res.data
        if (_this.newDataNumber !== null && _this.newDataNumber !== 0) {
          Indicator.close()
          Toast({
            message: '已更新' + _this.newDataNumber + '个最新项目',
            position: 'middle',
            duration: 2000
          })
        } else {
          Toast({
            message: '没有最新的项目',
            position: 'middle',
            duration: 2000
          })
        }
      })
    },
    judgejump (projectid) {
      let _this = this
      _this.projectid = projectid
      // this.axios.get('url/work/project/queryweixinproject?id=' + projectid + '')
      // .then(function (res) {
      //   // console.log(res.data)
      //   _this.project = res.data
      //   if (_this.STATE.state.loginState === true) {
      //     _this.judgetyep(projectid, _this.STATE.state.loginId)
      //   } else {
      //     _this.$router.push({path: '/project/projectDetail', query: { projectid: projectid }})
      //   }
      // })
      if (_this.STATE.state.loginState === true) {
          _this.judgetyep(projectid, _this.STATE.state.loginId)
        } else {
          _this.$router.push({path: '/project/projectDetail', query: { projectid: projectid }})
        }
    },
    // 获取用户状态
    judgetyep: function (projectid, accountid) {
      let _this = this
      this.axios({
        method: 'post',
        url: 'url/work/project/projectjudgetyep',
        params: {
          accountid: accountid,
          projectid: projectid,
          rememberMe: true
        }
      }).then(function (res) {
        _this.projectType = res.data
        // console.log(_this.projectType)
        if (_this.projectType === true || _this.project.account_id === _this.STATE.state.loginId) {
          _this.$router.push({name: 'myProjectDetail', params: { projectId: projectid }})
        } else {
          _this.$router.push({path: '/project/projectDetail', query: { projectid: projectid }})
        }
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios.get('url/work/project/queryweixinprojectlists?type=' + this.pjtType + '&rows=20&page=' + this.searchCondition.pageNo)
      .then(function (res) {
        Indicator.close()
        _this.pjtList = _this.pjtList.concat(res.data)
        if (res.data.length !== 10) {
          _this.allLoaded = true
        }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    getType: function () {
      let _this = this
      this.axios.get('url/work/project/queryweixinprojectlistType')
      .then(function (res) {
        _this.types = _this.types.concat(res.data)
      })
    }
  },
  // filters: {
  //   formatDate (time) {
  //     var date = new Date(time)
  //     return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
  //   }
  // }
}
</script>
<style scoped>
.pjt_type{
  text-align:center;
  border-bottom:1px solid #ccc;
  padding:12px 0;
  overflow-x:auto;
  white-space:nowrap;
}
.pjt_type span{
   display:inline-block;
   min-width:56px;
   height:26px;
   font-size:12px;
   margin:0 3px;
   line-height:26px;
   background-color:#f7f7f7;
   border:1px solid #dcdcdc;
   -webkit-border-radiu:5px;
   -moz-border-radiu:5px;
   border-radius:5px;
  }
  .pjt_type .selected{
    color:#fff;
    background-color:#108ee9;
  }
  .pjt_list{
    background-color:#f0eff5;
  }
  .pjt_list li{
    border-top:1px solid #ccc;
    border-bottom:1px solid #ccc;
    margin-bottom:5px;
    background-color:#fff;
    padding:10px 15px;
  }
  .pjt_list li .bgimg{
    width:44px;
    height:44px;
    float:right;
    margin-right:-15px;
    margin-top:-10px;
    background-size:100% 100%;
  }
  .pjt_list li .zhaomu{
    background-image:url('../assets/img/main_app/state-4.png');
  }
  .pjt_list li .close{
    background-image:url('../assets/img/main_app/state-5.png');
  }
  .pjt_list li .jinxing{
    background-image:url('../assets/img/main_app/state-7.png');
  }
  .pjt_list li .over{
    background-image:url('../assets/img/main_app/state-8.png');
  }
  .pjt_list li .hezuo{
    background-image:url('../assets/img/main_app/state-6.png');
  }
  .pjt_list li .pingjia{
    background-image:url('../assets/img/main_app/state-9.png');
  }
  li .project_type{
    font-size:10px;
    background-color:#e9fafd;
    color:#108ee9;
    padding:3px 5px;
    -webkit-border-radiu:12px;
    -moz-border-radiu:12px;
    border-radius:12px;
  }
  li h4{
    font-size:14px;
    color:#727272;
    margin:5px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
  }
  li .money{
    font-size:18px;
    color:#3d4251;
    font-weight: bold;
  }
  li .pjt_skills{
    max-height:60px;
    overflow:hidden;
  }
  .pjt_skills span{
    display:inline-block;
    font-size:10px;
    padding:3px 5px;
    background-color:#f2f2f2;
    color:#a6a6a6;
    -webkit-border-radiu:5px;
    -moz-border-radiu:5px;
    border-radius:5px;
    margin:3px 10px;
  }
  .position span{
    font-size:10px;
    color:#727272;
    margin-right:29px;
  }
  .position span .fa-icon{
    color:#cecece;
    height:10px;
  }
  .people span{
    font-size:10px;
    color:#727272;
    margin-right:20px;
  }
  .people span span{
    margin:0 5px;
  }
  a{
    text-decoration: none;
  }
  .mint-loadmore{
    margin-bottom: 70px;
  }
</style>



// WEBPACK FOOTER //
// all_project.vue?8825c672